var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.733 0H2.643C1.462 0 .505.96.505 2.23s.957 2.172 2.136 2.172h17.09V24H2.643c-1.179 0-2.136-.935-2.136-2.087V2.515M2.76 2.182L19.733 2.182",
    transform: "translate(-289 -166) translate(249 137) translate(27 16) translate(13.153 13) translate(2.996 1)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.768 2.75c0 1.52-1.241 2.75-2.774 2.75S2.22 4.27 2.22 2.75 3.46 0 4.994 0c1.533 0 2.774 1.23 2.774 2.75zM9.988 10.45H0C0 7.717 2.235 5.5 4.994 5.5c2.758 0 4.994 2.217 4.994 4.95z",
    transform: "translate(-289 -166) translate(249 137) translate(27 16) translate(13.153 13) translate(8.09 10)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.dcf78f2d.svg";
export { ForwardRef as ReactComponent };